import { useEffect, useState } from "react";
import { Doughnut } from 'react-chartjs-2';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';

ChartJS.register(ArcElement, Tooltip, Legend);

function DoughnutChart({ data = {}, titleBarChar = "" }) {
  const [chartKey, setChartKey] = useState(0);

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
        legend: {
      position: "top",
      labels: {
        font: {
          family: 'Raleway, sans-serif',  
          size: 12,                       
          weight: 'normal',               
        },
        color: '#615858ff',                      
        boxWidth: 20,                       
      },
    },
       title: {
      display: true,
      text: titleBarChar,
      font: {
        family: 'Raleway, sans-serif', 
        size: 16,                      
        weight: 600,              
      },
      color:"black"
    },
     tooltip: {
      enabled: true,
      bodyFont: {
        family: 'Raleway, sans-serif', 
        size: 12,
      },
      titleFont: {
        family: 'Raleway, sans-serif', 
        size: 14,
      },
      callbacks: {
        label: function (context) {
          // `context.label` → nombre de la categoría
          // `context.parsed` → valor numérico
          // `context.dataset.backgroundColor` → color del segmento
          return `${context.label}: ${context.parsed}`;
        },
      },
    },
  },
  };

  useEffect(() => {
    const handleResize = () => {
      setChartKey(prevKey => prevKey - 1);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);


  return (
    <>
      {data?.datasets?.length > 0 ? (
        <Doughnut
          key={chartKey}
          style={{ width: '100%', height: '100%', margin: 'auto' }}
          options={options}
          data={data}
          
        />
      ) : (
        <p style={{fontFamily: 'Raleway, sans-serif', fontSize:"14px",color:"#AEA9A9"}}>No hay datos disponibles.</p>
      )}
    </>
  );
}

export default DoughnutChart;
